module.exports = __webpack_public_path__ + "static/img/4.b1a56d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/4.jpg
// module id = 7AgK
// module chunks = 1